import { useStore } from "effector-react"
import React, { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { $notifyData, clearNotifyData, notificationSubscribe, onNotificationFromServerCome, setNotifyData } from "../../notification"
export const FcmNotification = () => {
  const notifyData = useStore($notifyData)
  const history = useHistory()

  useEffect(() => {
    notificationSubscribe()
    navigator.serviceWorker.addEventListener("message", onNotificationFromServerCome );
  }, [])

  useEffect(() => {
    if(notifyData.canInterruptUser) {
      if( "pathTogo" in notifyData.data) {
        //@ts-ignore
        let path2go: string = notifyData.data["pathTogo"]
        clearNotifyData()
        history.push(path2go)
      }
    }
  }, [notifyData])
  return <></>
}
